import { useEffect, useState } from 'react'
import { X } from 'lucide-react'
import { useLocation } from 'react-router-dom'

const DISMISSED_KEY = 'fastaudio-dismissed-announcements'

export default function AnnouncementBanner() {
  const location = useLocation()
  const [items, setItems] = useState([])
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem(DISMISSED_KEY) || '[]') } catch { return [] }
  })
  useEffect(() => {
    const placement = location.pathname === '/' ? 'homepage' : 'downloader'
    fetch(`/admin/api/public/announcements?placement=${placement}`)
      .then(response => response.ok ? response.json() : [])
      .then(setItems)
      .catch(() => setItems([]))
  }, [location.pathname])
  const dismiss = id => {
    const next = [...new Set([...dismissed, id])]
    setDismissed(next)
    localStorage.setItem(DISMISSED_KEY, JSON.stringify(next))
  }
  const visible = items.filter(item => !dismissed.includes(item.id))
  if (!visible.length) return null
  return (
    <section aria-label="Site announcements" className="border-b border-primary/20 bg-primary/5">
      {visible.map(item => (
        <div key={item.id} className="relative max-w-6xl mx-auto px-10 py-2 text-center text-sm text-foreground">
          <strong>{item.title}: </strong><span>{item.body.replace(/<[^>]*>/g, '')}</span>
          <button type="button" onClick={() => dismiss(item.id)} aria-label={`Dismiss ${item.title}`}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-muted">
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </section>
  )
}